// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ilu_A","icon":"styles_icon__2TWED"};